import React, {
  useState,
  useContext,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from 'react'
import './login.less'
import { injectIntl, FormattedMessage, WrappedComponentProps } from 'react-intl'
import {
  Row,
  Input,
  Button,
  Card,
  Modal,
  Form,
  notification,
  Tabs
} from 'antd'
import { isEffective } from './user-util'
import { LOGIN_URL, client, GetQueryString } from './login-util'
import mkp from './imgs/mkp.svg'
// import mkp from './imgs/mkp.png'
import thirdParty from './imgs/third-party.svg'
import Cookies from 'universal-cookie'
import { FirstLoginContext } from './contexts/login'
// import { TopNavbarContext, top_navbar_type } from '../../contexts/top-navbar';
import { http_props_type, http_request_new } from '../../http-worker/http-func'
import { RouteComponentProps } from 'react-router-dom'
import { LOGIN_URLS } from './constants/urls_path.constant'
import { SSO } from '../../shared-functions/constants/login'
import md5 from 'js-md5'
import CryptoJS from "crypto-js"

const cookies = new Cookies();
const { TabPane } = Tabs;

interface tab_type {
  /** 第幾個頁籤 */
  key: number
  /** 頁籤顯示名稱 */
  name: string
  /** 登入驗證的路徑，不填的話默認為 "v4.0/auth" */
  auth_url?: string
}

export interface sign_in_type {
  is_sso?: 1
  sso_portal_origin?: 1
  logo_style?: React.CSSProperties
  /**
   * 多重登入方法，為一個數組
   *
   * 如果只有一個，不會顯示頁籤列，但會使用其登入驗證路徑
   *
   * 有多個登入方法才會顯示頁籤列
   */
  login_methods?: tab_type[]

  /**
   * auth 請求的自訂 body 參數
   */
  custom_body?: object

  /** 自訂送出後執行的動作 */
  custom_handle_submit: (paras?: any) => void
  setting_params?: any
  has_third_party?: boolean
  app_name?: any
  show_remember_me?: boolean
  show_forget_pwd?: boolean
  show_sign_up?: boolean
}

export const SignIn = injectIntl(
  (
    props: WrappedComponentProps<'intl'> &
      RouteComponentProps<any> &
      http_props_type &
      sign_in_type,
  ) => {
    const redirectUri: React.MutableRefObject<string | null> = useRef(
      GetQueryString('redirectUri') || GetQueryString('redirectUrl'),
    );
    const [login_modal_visible, set_login_modal_visible]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useContext(FirstLoginContext);
    const [signin_ing, set_signin_ing]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false);
    const [is_minisite, set_is_minisite]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false);
    const [switch_login_mode, set_switch_login_mode]: [number | undefined, React.Dispatch<React.SetStateAction<number | undefined>>] = useState<number | undefined>();
    const [current_datacenter, set_current_datacenter] = useState({} as any);
    const [modal_info, set_modal_info] = useState({} as any);
    const [third_party, set_third_party] = useState([] as any)
    const [is_remember, set_is_remember] = useState(false);
    const [tab_selected, set_tab_selected]: [tab_type | undefined, React.Dispatch<React.SetStateAction<tab_type | undefined>>] = useState<tab_type | undefined>();
    const { intl, history, app_name, is_sso, setting_params, sso_portal_origin, logo_style, login_methods, show_forget_pwd, show_remember_me, show_sign_up, custom_handle_submit, has_third_party } = useMemo(()=> props, [props]);
    const [form] = Form.useForm();
    const { getFieldsValue } = form;
    const [is_double_factor, set_is_double_factor]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false)

    const props_new = useMemo(
      () => ({
        history: props.history,
        redirect_url: props.redirect_url,
        log_out: props.log_out,
      }),
      [props.history, props.redirect_url, props.log_out],
    );
    const {formatMessage} = useMemo(()=> intl, [intl]);
    const is_not_sso = useMemo(
      () =>
        login_methods?.[switch_login_mode || 0].name.toLocaleLowerCase() !==
        SSO,
      [login_methods, switch_login_mode],
    )


    useEffect((): void => {
      set_tab_selected(login_methods?.[0]);
      set_is_minisite(window.location.hostname.includes('minisite'))
    }, [login_methods]);

    useEffect(() => {
      const dc = client.find((c) => c.host === window.location.host);
      if (isEffective(dc)) set_current_datacenter(dc);
    }, [set_current_datacenter]);

    const handle_fetch_third_party = useCallback(async () => {
      try{
      const res:any = await http_request_new({
        key: 'thirdparty',
        url: '/v4.0/oauth/third-part',
        no_refresh: 1,
        method: 0,
        props: { history },
        no_underlined_key: 1,
      })
      if (res && !res.code) {
        set_third_party(Object.keys(res).map((i: any) => res[i]))
      }}catch{
      }
    }, [set_third_party, history])

    useEffect(()=>{
      if(has_third_party) {
        handle_fetch_third_party()
      }
    },[handle_fetch_third_party, has_third_party])

  // 是否启用双因素登录
  useEffect(() => {
    (
      async () => {
        await http_request_new({
          key: 'params',
          url: `/v4.0/params`,
          method: 0,
          props: { history },
          custom_warning: (res: any) => {
            set_is_double_factor(res?.multifactor_auth_enable)
          }
        })
      }
    )()
  }, [history, set_is_double_factor])

  // 双因素登录AES(+Base64)加密密码
  const encryptByAES  = useCallback((pwd: string, user: string) => {
    let AESKey = md5(user);
    let key = CryptoJS.enc.Utf8.parse(AESKey);
    let iv = CryptoJS.enc.Utf8.parse(AESKey.substr(0, 16)); // 偏移量：规定的是key前15位
    let srcs = CryptoJS.enc.Utf8.parse(pwd);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
  }, [])

    const handleSubmit = useCallback(async (): Promise<void> => {
      set_signin_ing(true);
      const { username, password } = getFieldsValue();
      if (is_remember) {
        localStorage.setItem('SignInUsername', username);
      } else {
        localStorage.removeItem('SignInUsername')
      }
      if(custom_handle_submit){
        custom_handle_submit({username, password, setSignLoading: set_signin_ing})
      }else {
        try {
          const login_res: any = await http_request_new({
            key: 'auth',
            props: props_new,
            url: is_double_factor ? '/v4.0/auth/multifactor/gen-auth-code' : `/${tab_selected?.auth_url || 'v4.0/auth'}`,
            method: 1,
            body: {username, password: is_double_factor ? encryptByAES(password, username): password, ...props.custom_body},
            no_refresh: 1,
            custom_warning: (response: any) => {
              const {code, message} = response;
              if (code === 401 && message === 'FirstLogin') {
                Modal.info({
                  title: intl.formatMessage({id: 'password_error'}),
                  content: (
                    <p>{intl.formatMessage({id: 'password_check_email'})}</p>
                  ),
                  okText: intl.formatMessage({id: 'ok'}),
                  autoFocusButton: null,
                })
              } else if (
                message ===
                'The password has not been changed for a long time. It is recommended to change the password.'
              ) {
                notification.warning({
                  message: intl.formatMessage({id: 'warning'}),
                  description: message,
                })
              } else if (
                message ===
                'User is in Inactive status,Please activate the user first.'
              ) {
                set_modal_info({
                  ok: 'activate_account',
                  cancel: 'cancel',
                  title: 'activate_account',
                  message: 'activate_account_message',
                });
                set_login_modal_visible(true)
              } else if (code) {
                if (tab_selected?.auth_url) {
                  if (code === 401 && response?.errors?.[0]?.message === 'username or password not correct') {
                    notification.error({
                      message: intl.formatMessage({id: 'error'}),
                      description: intl.formatMessage({id: 'err_pwd_account'}),
                    })
                  } else {
                    notification.warning({
                      message: intl.formatMessage({id: 'warning'}),
                      description: message,
                    })
                  }
                } else {
                  notification.warning({
                    message: intl.formatMessage({id: 'warning'}),
                    description: message,
                  })
                }
              }
            },
          });
          set_signin_ing(false);
          let first_flag = true;
          if (
            login_res?.message === 'FirstLogin' &&
            (is_sso || sso_portal_origin)
          ) {
            set_modal_info({
              ok: 'go_to_change_pwd',
              cancel: 'skip',
              title: 'system_notification',
              message: 'system_notification_sub',
            });
            set_login_modal_visible(true);
            first_flag = false
          }
          if (first_flag && login_res && !login_res.code) {
            if (is_double_factor) {
              history.push({ pathname: LOGIN_URL.verify, state: { authCode: login_res?.auth_code } })
              sessionStorage.setItem('authCode', login_res?.authCode);
            } else {
              redirectUri.current ? (window.location.href = redirectUri.current) : history.push('/')
            }
          }
        } catch {
          set_signin_ing(false)
        }
      }
    }, [
      getFieldsValue,
      props_new,
      history,
      set_login_modal_visible,
      intl,
      is_sso,
      sso_portal_origin,
      tab_selected?.auth_url,
      props.custom_body,
      is_remember,
      custom_handle_submit,
      is_double_factor,
      encryptByAES
    ]);

    const to_forgot_password = useCallback(() => {
      history.push(LOGIN_URL.forgotPwd)
    }, [history]);

    const to_resend_email = useCallback(() => {
      history.push(LOGIN_URL.resendEmail)
    }, [history])

    const handle_prompt_ok = useCallback(async (): Promise<void> => {
      set_login_modal_visible(false);
      const username = form.getFieldValue('username');
      if (modal_info?.title === 'system_notification') {
        if (is_sso) {
          history.push({
            pathname: '/users/changepwd',
            state: { username: username, login_modal_visible: true },
          })
        } else if (sso_portal_origin) {
          window.open(
            `${sso_portal_origin}/users/changepwd?redirectUrl=${window.location.origin}`,
            '_self',
          )
        }
      } else if (modal_info?.title === 'activate_account') {
        history.push({ pathname: '/login/activate', state: { username } })
      }
    }, [
      history,
      set_login_modal_visible,
      is_sso,
      sso_portal_origin,
      form,
      modal_info?.title,
    ]);

    const handle_prompt_cancel = useCallback(async (): Promise<void> => {
      set_login_modal_visible(false);
      modal_info?.title === 'system_notification' && history.push('/')
    }, [history, set_login_modal_visible, modal_info?.title]);

    const handle_click_advantech = useCallback(() => {
      if (isEffective(current_datacenter)) {
        sessionStorage.setItem('loginType', 'loginWithMyAdvantech');
        // 由于返回时的url中不含redirectUrl，所以在这里得暂存一下，放入sessionStorage中
        const reg = /(\.\w+\.wise-paas.*)/;
        const result = window.location.hostname.match(reg);
        if (Array.isArray(result)) {
          const domain = result[1].substr(1);
          cookies.set('sso-myadvantech-oauth', 'c3NvLW15YWR2YW50ZWNoLW9hdXRo', {
            domain: domain,
            path: '/',
          })
        }
        window.location.href = current_datacenter?.host.includes('hz') ? LOGIN_URLS.HZ_MYADVANTECH(current_datacenter) : LOGIN_URLS.NORMAL_MYADVANTECH(current_datacenter)
      }
    }, [current_datacenter]);

    // 点击第三方登录
    const handle_click_third_party = useCallback((third_party) => {
      const reg = /(\.\w+\.wise-paas.*)/
      const result = window.location.hostname.match(reg)
      if (Array.isArray(result)) {
        const domain = result[1].substr(1)
        cookies.set('sso-third-party-oauth', third_party.partenerName, {
          domain: domain,
          path: '/',
        })
      }
      window.location.href = third_party.endpoint
    }, [])

    const to_register = useCallback(() => {
      history.push(LOGIN_URL.register)
    }, [history]);

    const login_mode = useMemo(() => {
      return (
        <div className="login_tab">
          {login_methods && login_methods.length > 1 ? (
            <Tabs
              centered
              size="large"
              activeKey={switch_login_mode?.toString()}
              onChange={(switch_login_mode: string): void => {
                form.resetFields();
                const switch_login_mode_number = Number(switch_login_mode);
                set_switch_login_mode(switch_login_mode_number);
                set_tab_selected(login_methods?.[switch_login_mode_number]);
                sessionStorage?.setItem?.('login_tab', switch_login_mode)
              }}
            >
              {login_methods?.map((item: any) => (
                <TabPane
                  tab={intl.formatMessage({ id: item?.name })}
                  key={item?.key}
                />
              ))}
            </Tabs>
          ) : (
            <div className="login_tab" style={{ display: 'none' }}>
              <Tabs size="large">
                <Tabs.TabPane tab="Tab 1" key="1"/>
              </Tabs>
            </div>
          )}
        </div>
      )
    }, [intl, login_methods, switch_login_mode, form]);

    const rememberMeFun = () => {
      set_is_remember((old_status: boolean) => !old_status)
    };

    useEffect(() => {
      const storage = localStorage.getItem('SignInUsername');
      // const time = new Date().getTime();
      if(storage) {
        // const obj = JSON.parse(storage || '');
        // if (time >= obj.time) {
        //   localStorage.removeItem('SignInUsername');
        //   set_is_remember(false);
        //   return
        // }
        set_is_remember(true);
        form.setFieldsValue({username: storage})
      } else {
        set_is_remember(false)
      }
    }, [form]);

    return (
      <Row>
        <Card className="login-box">
          {(setting_params&&Object.keys(setting_params).length > 0 && (setting_params?.loginBoxTopLogo ? (
            <Row
              style={{
                visibility: setting_params?.loginBoxTopLogoHide
                  ? 'visible'
                  : 'hidden',
                backgroundImage: `url(${setting_params?.loginBoxTopLogo})`,
                height: 64,
                width: 320,
                backgroundSize: '100% 100%',
                backgroundRepeat: 'no-repeat',
              }}
            />
          ) : (
            <Row
              className="logo-1"
              style={{
                visibility: setting_params?.loginBoxTopLogoHide
                  ? 'visible'
                  : 'hidden',
                  ...(logo_style ? logo_style : {})
              }}
            />)
          )) || <Row
            className="logo-1" style={logo_style ? logo_style : {}}/>}
          <span className="sign-in-sub">
            <FormattedMessage id="log_in_sub" values={{name: app_name || formatMessage({id: 'login_app_name'})}}/>
          </span>
          {login_mode}
          <Form
            className="login-form sign-in-form"
            onFinish={handleSubmit}
            form={form}
          >
            <Form.Item
              className={'username-input'}
              name="username"
              rules={[
                {
                  required: true,
                  message: <FormattedMessage id='u_n_or_p_w_d_error'/>,
                },
              ]}
            >
              <Input
                placeholder={intl.formatMessage({ id: setting_params && Object.keys(setting_params).length && setting_params?.loginAuthEnable ? 'email_address' : 'username_email' })}
                size="large"
                autoComplete="on"
              />
            </Form.Item>
            <Form.Item
              className={'password-input'}
              name="password"
              rules={[
                {
                  required: true,
                  message: <FormattedMessage id='u_n_or_p_w_d_error'/>,
                },
              ]}
            >
              <Input.Password
                placeholder={intl.formatMessage({ id: 'password' })}
                size="large"
                autoComplete="on"
                iconRender={(_: any) => <span/>}
              />
            </Form.Item>
            <Form.Item>
              {!is_minisite && (
                <Row
                  justify="space-between"
                  align="middle"
                  style={{ height: '40px', marginBottom: '12px' }}
                >
                  {/* {!is_not_sso && ((setting_params && Object.keys(setting_params).length > 0 && (
                    <span
                      className="like-a"
                      style={{
                        fontWeight: 600,
                        display: setting_params?.loginBoxHideRegister
                          ? 'inline'
                          : 'none',
                      }}
                      onClick={to_register}
                    >
                      <FormattedMessage id="registered" />
                    </span>
                  )) ||
                  <span
                    className="like-a"
                    onClick={to_register}
                  >
                      <FormattedMessage id="registered" />
                    </span>
                    )} */}
                  {show_remember_me && <span className={'vertical-center grey pointer remember-me'} onClick={rememberMeFun}>
                      <span className={`icon ${is_remember ? 'checkbox-selected' : 'checkbox'}`}/>
                      <FormattedMessage id="remember_me"/>
                    </span>}
                  {show_forget_pwd && (
                    <span className="primary-link" onClick={to_forgot_password}>
                      <FormattedMessage id="forgot_pwd"/>
                    </span>
                  )}
                </Row>
              )}
              <Row
                className={`${is_minisite && 'mt-20'}`}
                justify="center"
                align="bottom"
              >
                <Button
                  type="primary"
                  htmlType="submit"
                  className="form-submit-button"
                  loading={signin_ing}
                >
                  <span>
                    <FormattedMessage id="sign_in"/>
                  </span>
                </Button>
              </Row>
              <div className={'third-party-content'}>
                {/* (third_party && third_party.length > 0 && (
              <>
                <Row className="mkp_login">
                        <div className="divider-or">
                          <FormattedMessage id="or_third_party" />
                        </div>
                </Row>
                <Spin spinning={is_third_party_loading}>
                  <div className="mkp_logo text-center">
                    {third_party.map((item: any, index: any) => (
                      <div className="third-party-logo" key={index}>
                        <img
                          src={item.logoImage}
                          alt={item.partenerName}
                          className="pointer"
                          onClick={() => handle_click_third_party(item)}
                        />
                      </div>
                    ))}
                    {isEffective(current_datacenter) && is_sso && (
                      <div className="advantech-logo">
                        <img
                          src={mkp}
                          alt="advantech"
                          className="pointer"
                          onClick={handle_click_advantech}
                        />
                      </div>
                    )}
                  </div>
                </Spin>
              </>
            )) ||  (isEffective(current_datacenter) && is_sso && */((
                    <>
                      { ((isEffective(current_datacenter) && is_sso) || (third_party && third_party.length > 0)) &&
                        <Row className="mkp_login">
                          <div className="divider-or">
                            <FormattedMessage id="or_third_party" />
                          </div>
                        </Row>
                      }
                        <div className="mkp_logo text-center">
                          {isEffective(current_datacenter) && is_sso && <div className="advantech-logo third-party-btn" onClick={handle_click_advantech}>
                            <img
                              src={mkp}
                              alt="advantech"
                              className="pointer"
                            />
                            <span>MyAdvantech</span>
                          </div>}
                          {third_party && third_party.length > 0 &&
                          // <Spin spinning={is_third_party_loading}>
                            third_party?.map((item: any) => (
                              <div className="advantech-logo third-party-btn" onClick={() => handle_click_third_party(item)}>
                                <img
                                  src={item?.logoImage || thirdParty}
                                  alt={item?.partenerName || 'Third party'}
                                  className="pointer"
                                />
                                <span>{item?.partenerName || 'Third party'}</span>
                              </div>
                            ))}
                           {/* </Spin>} */}
                        </div>
                    </>
            ))}
              </div>
              {show_sign_up && <>
                <div className="divider"/>
                <Row
                  justify="center"
                  align="middle"
                  style={{ marginTop: '24px', visibility: setting_params?.loginBoxHideRegister? 'visible': 'hidden' }}
                >
                <span className={'primary-link'} onClick={to_register}>
                  <FormattedMessage id="sign_up_text"/>
                </span>
                </Row>
              </>}
          {!is_minisite && (
            <Row className="signin-footer" align="bottom" justify="center">
              {!is_not_sso && ((setting_params&&Object.keys(setting_params).length > 0&&(
                <span
                  className="like-a"
                  onClick={to_resend_email}
                  style={{
                    visibility: setting_params?.loginBoxHideResend
                      ? 'visible'
                      : 'hidden',
                  }}
                >
                  <FormattedMessage id="not_receive_email"></FormattedMessage>
                </span>
              ))||<span
              className="like-a"
              onClick={to_resend_email}
            >
              <FormattedMessage id="not_receive_email"></FormattedMessage>
            </span>)}
            </Row>
          )}
            </Form.Item>
          </Form>


      </Card>
      <Modal
        title={intl.formatMessage({ id: modal_info?.title || 'system_notification' })}
        visible={login_modal_visible}
        onOk={handle_prompt_ok}
        onCancel={handle_prompt_cancel}
        maskClosable={false}
        okText={intl.formatMessage({ id: modal_info?.ok || 'go_to_change_pwd' })}
        cancelText={intl.formatMessage({ id: modal_info?.cancel || 'skip' })}
      >
        <p>
          <FormattedMessage id={modal_info?.message || 'system_notification_sub'} />
        </p>
      </Modal>
    </Row>
  );
});
